import { Component, OnInit } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthService } from '../auth/auth.service';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons/faWhatsapp';

@Component({
  selector: 'app-media-type',
  templateUrl: './media-type.component.html',
  styleUrls: ['./media-type.component.scss']
})
export class MediaTypeComponent implements OnInit {

  getRetailerNotificationsdata: any;
  modalImage: any = "";
  attachurl: any;
  constructor( private modalService: NgbModal,private auth: AuthService,private ngxService: NgxUiLoaderService,private toastr: ToastrService, ) { }

  ngOnInit(): void {
    this.getRetailerNotifications();
  }
  getRetailerNotifications(){
    this.ngxService.start();
    this.auth.getRetailerNotificationsApi('PRINT_MEDIA').subscribe((res:any)=>{
      this.ngxService.stop();

      if(res.status_code == 1){
        this.getRetailerNotificationsdata = res.object
        console.log(this.getRetailerNotificationsdata);
        this.toastr.success(res.message);
      

      }else {
        this.getRetailerNotificationsdata = [];

        this.toastr.error(res.error.message);

      }
    },err=>{
      this.ngxService.stop();

    })
  }

  handleTabChange(value){

  }
  seeImage(image, modal,attachurl) {
    window.open(image);
    // window.print();
    // this.attachurl=attachurl;
    // let imageDownload = false;
    // let docsTypes = [
    //   ".pdf",
    //   ".doc",
    //   ".docx",
    //   ".html",
    //   ".txt",
    //   ".csv",
    //   ".xla",
    //   ".xls",
    // ];
    // docsTypes.forEach((docs) => {
    //   if (image.includes(docs)) {
    //     window.open(image);
    //     imageDownload = true;
    //     return true;
    //   }
    // });
    // if (!imageDownload) {
    //   this.modalImage = image;
    //   console.log(image);
    //   this.open(modal);
      
    
    // }
  }
  closeResult: string;
  open(content) {
    console.log("content", content);
    this.modalService.open(content, { scrollable: true }).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }
}
